/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = {};
  try { data = JSON.parse(XMLHttpRequest.responseText); } catch (e) {}
  var str;
  if (data && data.message) {
    str = data.description;
  } else {
    str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id == "add-item-qv") {
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
              jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 1200);
          }
          Shopify.openMiniCart();
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.openMiniCart = function() {
  jQuery("body").addClass("fix");
  jQuery(".minicart-inner").addClass("show");
  jQuery("#modalAddToCart").modal && jQuery("#modalAddToCart").modal("hide");
  jQuery("#quickViewModal").modal && jQuery("#quickViewModal").modal("hide");
};
Shopify.cartPopap = function(variant_id) {
  Shopify.openMiniCart();
};
Shopify.cartPopapForm = function(variant_id) {
  Shopify.openMiniCart();
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  var removeSvg = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 5h10M6.5 5V3.5a1 1 0 011-1h1a1 1 0 011 1V5m-5 0l.7 8.1a1 1 0 001 .9h3.6a1 1 0 001-.9L12 5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var buildItemHtml = function(item) {
    return '<div class="minicart-item">' +
      '<div class="minicart-thumb"><a href="' + item.url + '"><img src="' + item.image + '" alt=""></a></div>' +
      '<div class="minicart-content">' +
        '<h3 class="product-name"><a href="' + item.url + '">' + item.title + '</a></h3>' +
        '<p>' +
          '<span class="cart-quantity">' + item.quantity + ' <strong>&times;</strong></span>' +
          '<span class="cart-price">' + Shopify.formatMoney(item.price, formatMoney) + '</span>' +
        '</p>' +
      '</div>' +
      '<a class="minicart-remove" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')" aria-label="Remove item">' + removeSvg + '</a>' +
    '</div>';
  };
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          if (value.length) {
            jQuery(".minicart-content-box").css({"display": ""});
            jQuery(".k-cart-foot").css({"display": ""});
            jQuery(".cart-empty-title").css({"display": "none"});

            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery(buildItemHtml(item)).appendTo(table);
            });
          }
          else {
            jQuery(".minicart-content-box").css({"display": "none"});
            jQuery(".k-cart-foot").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};